module.exports = __webpack_public_path__ + "img/UTGUNL-6.b3b105fc.jpg";